import { Toggle, ToggleGroup, Translation } from '@ps/web-shared-components';
import type { Validators } from '@ps/web-shared-validators';
import { required } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React from 'react';
import type { FieldMetaState } from 'react-final-form';

import type { FieldNameProp } from '@swf/core/types/Props';

import {
  TXTCLI_Current_Account,
  TXTWCL_Checking_Account,
  TXTWCL_Please_select_your_account_typ_ELL,
  TXTWCL_Saving_Account,
  TXTWCL_Select_your_account_type
} from './AccountTypeToggleGroup.messages.json';
import { error, label, labelError, toggleContainer } from './AccountTypeToggleGroup.scss';

export interface Validator {
  accountType?: Validators;
  accountNumber?: Validators;
  institution?: Validators;
  branch?: Validators;
}

interface Props extends FieldNameProp {
  meta: FieldMetaState<string>;
  validators?: Validator;
  useCurrent?: boolean;
}

const AccountTypeToggleGroup: React.FC<Props> = ({
  fieldName,
  meta,
  validators,
  useCurrent = false
}) => {
  const hasToggleError = (meta.touched || meta.dirty) && meta.error && meta.error.message;

  return (
    <ToggleGroup
      id={`${fieldName}.accountTypeC`}
      label={<Translation {...TXTWCL_Select_your_account_type} />}
      labelClassName={classNames(label, {
        [labelError]: hasToggleError
      })}
      type="radio"
      className={toggleContainer}
    >
      <Toggle
        id={`${fieldName}.accountTypeC`}
        name={`${fieldName}.accountType`}
        label={useCurrent ? TXTCLI_Current_Account : TXTWCL_Checking_Account}
        type="radio"
        value="C"
        validators={[
          required(TXTWCL_Please_select_your_account_typ_ELL),
          ...(validators?.accountType || [])
        ]}
        error={hasToggleError}
      />
      <Toggle
        id={`${fieldName}.accountTypeS`}
        name={`${fieldName}.accountType`}
        label={TXTWCL_Saving_Account}
        type="radio"
        value="S"
        error={hasToggleError}
      />
      {hasToggleError && (
        <p className={error}>
          <Translation {...meta.error.message} />
        </p>
      )}
    </ToggleGroup>
  );
};
export default AccountTypeToggleGroup;
